import { StoredScheduleBlock } from './layout/StoredScheduleBlock';
import {
  validateScheduleBlocks,
  ValidateScheduleBlocksOptions,
} from './validateScheduleBlocks';

/**
 * Validates and THROWS (with a serialized diff) instead of allowing a corrupt
 * write. `context` names the write path for the error message.
 */
export function assertValidScheduleBlocks(
  blocks: StoredScheduleBlock[],
  context: string,
  options: ValidateScheduleBlocksOptions = {},
): void {
  const { ok, errors } = validateScheduleBlocks(blocks, options);

  if (!ok) {
    const message =
      `${context}: refusing to persist corrupt views.schedule.blocks:\n` +
      ` - ${errors.join('\n - ')}\n` +
      `blocks: ${JSON.stringify(blocks)}`;

    console.error(message);
    throw new Error(message);
  }
}
